import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>,
);

// PWA: capture install prompt + register service worker
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    window.__bsInstallPrompt = e;
    window.dispatchEvent(new CustomEvent("bs-install-available"));
  });
  window.addEventListener("appinstalled", () => {
    window.__bsInstallPrompt = null;
    try { localStorage.setItem("bs_pwa_installed", "1"); } catch { /* ignore */ }
    window.dispatchEvent(new CustomEvent("bs-install-done"));
  });
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/service-worker.js").catch((err) => {
        console.warn("SW registration failed:", err);
      });
    });
  }
}
